// src/App.js
import React, { useState, useEffect } from 'react';
import Navbar from './Components/Navbar/Navbar';
import Home from './Components/Home/Mainpage';
import Contact from './Components/Contact-Us';
import About from './Components/About-Us';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from './Components/Footer/Footer';
import AllahNames from './Components/NamesofAllah/AllahNames';
import QiblaCompass from './Components/QiblaDirection/QiblaCompass';
import Quranformats from './Components/Quran/Quranformats';
import BySurah from './Components/Quran/BySurah/BySurah';
import SurahDetails from './Components/Quran/BySurah/SurahDetails';
import ByJuz from './Components/Quran/ByJuz/ByJuz';
import JuzDetails from './Components/Quran/ByJuz/JuzDetails';
import FeedbackForm from './Components/Feedback';
import Lectures from './Components/IslamicLectures/Lectures';
import Hadith from './Components/HadithBooks/Hadith';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const pre = document.getElementById('pre');
    if (pre) {
      setTimeout(() => {
        pre.style.display = 'none';
        setLoading(false);
      }, 500);
    }
  }, []);

  return (
    !loading && (
      <div>
        <Navbar />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/Contact-Us" element={<Contact />} />
            <Route path="/About-Us" element={<About />} />
            <Route path="/AllahNames" element={<AllahNames />} />
            <Route path="/Qibla" element={<QiblaCompass />} />
            <Route path="/HolyQuran" element={<Quranformats />} />
            <Route path="/BySurah" element={<BySurah />} />
            <Route path="/surah/:number" element={<SurahDetails />} />
            <Route path="/ByJuz" element={<ByJuz />} />
            <Route path="/juz/:juz" element={<JuzDetails />} />
            <Route path="/Feedback" element={<FeedbackForm />} />
            <Route path="/Lectures" element={<Lectures />} />
            <Route path="/Hadith" element={<Hadith />} />
          </Routes>
        </BrowserRouter>
        <Footer />
      </div>
    )
  );
}

export default App;
